import React, { useState } from 'react';
import { Header } from './components/Header';
import { BookingProvider } from './context/BookingContext';
import { BookingSteps } from './components/BookingSteps';
export function App() {
  return <BookingProvider data-id="element-0">
      <div className="min-h-screen bg-gradient-to-b from-[#3B2A2A] to-[#2A1E1E]" data-id="element-1">
        <Header data-id="element-2" />
        <main className="container mx-auto px-4 py-8 max-w-4xl" data-id="element-3">
          <BookingSteps data-id="element-4" />
        </main>
      </div>
    </BookingProvider>;
}